import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { DashboardTab } from '../../../services/tenant-config-service';

interface TabFormData {
  id?: string;
  label: string;
  tag: string;
  is_active: boolean;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  formData: TabFormData;
  setFormData: (data: TabFormData) => void;
  items: DashboardTab[];
}

export default function TabModal({
  isOpen,
  onClose,
  onSubmit,
  formData,
  setFormData,
}: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>{formData.id ? 'Edit Tab' : 'Add New Tab'}</ModalHeader>
        <ModalBody>
          <div className="space-y-4">
            <Input
              label="Tab Label"
              placeholder="Enter tab name"
              value={formData.label}
              onChange={(e) =>
                setFormData({ ...formData, label: e.target.value })
              }
            />
            <Input
              label="Tag"
              placeholder="Enter tag name"
              value={formData.tag}
              isDisabled={formData?.id !== ''}
              onChange={(e) =>
                setFormData({ ...formData, tag: e.target.value })
              }
            />
          </div>
        </ModalBody>
        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={onSubmit}
            isDisabled={!formData.label.trim() || !formData.tag.trim()}
          >
            {formData.id ? 'Update Tab' : 'Add Tab'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
